module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_Cameroon.81c69015.jpg";